module.exports = __webpack_public_path__ + "img/lubomyr-melnyk1.f21b9d3e.jpg";